import React from 'react';
import styled, { css } from 'styled-components';
export const StepperBase = styled.div.attrs({
    className: 'stepper',
}) `
  display: flex;
  flex-direction: column;
`;
// The circle can be active, skipped, completed
export const Circle = styled.div.attrs(({ $active = false, $completed = false, $skipped = false, children, }) => {
    if ($active)
        return { children };
    if ($skipped)
        return { children: null };
    if ($completed)
        return { children: React.createElement("i", null, "check") };
    return { children };
}) `
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  width: 32px;
  height: 32px;
  margin: 0;
  margin-right: 16px;

  border-radius: 50%;

  background: var(--color-surface-border);

  & > i {
    font-size: 16px;
    line-height: 16px;
  }

  ${({ $active }) => $active &&
    css `
      font-weight: 600;
      color: var(--color-on-primary);
      background: var(--color-selection);
    `}
`;
export const Title = styled.div `
  display: flex;

  & > p {
    flex-shrink: 0;
    padding-right: 32px;
    background: var(--color-background);
  }
`;
export const Section = styled.div `
  position: relative;
  background: transparent;
  border: none;
  text-align: left;
  padding: 0;
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'auto')};

  display: grid;

  grid-template-columns: 48px auto;
  grid-template-rows: 24px 24px;

  & > ${Circle} {
    grid-row: 1 / span 2;
  }

  & > ${Title} {
    text-decoration: ${({ onClick }) => (onClick ? 'underline' : 'none')};
  }
`;
export const Line = styled.div `
  position: absolute;
  top: 10px;
  left: 48px;
  right: 32px;
  background: var(--color-border);
  height: 1px;
  margin: 0;
  z-index: -1;
`;
export const Caption = styled.p `
  font-size: 14px;

  margin: 0;
`;
export const StyledStep = styled.div `
  margin: 16px 0;
`;
export const VerticalLegend = styled.div `
  display: flex;
  flex-direction: column;
  position: relative;

  &:not(:last-child) {
    padding-bottom: 32px;
  }

  & > ${StyledStep} {
    margin-left: 16px;
  }

  & > ${Line} {
    left: 16px;
    top: 48px;
    bottom: 16px;
    width: 1px;
    height: initial;

    & > hr {
      margin: 11px 32px 11px 0;
    }
  }
`;
export const HorizontalLegend = styled.div `
  display: grid;
  grid-template-rows: 24px 24px;
  grid-template-columns: repeat(${({ $stepCount }) => $stepCount - 1}, 1fr) auto;

  & > hr {
    margin: 11px 32px 11px 0;
  }
`;
